<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Online Reservation'"
        :buttons="[
          {
            title: 'Reload',
            icon: 'fa fa-sync',
            emit: 'reload',
          },
        ]"
        @reload="get()"
      ></cardHead>

      <ul
        class="nav nav-tabs profile-tab"
        style="overflow-x:auto; overflow-y:hidden; margin-bottom:0;"
      >
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Customers'"
            :class="{ active: tab == 'Customers' }"
            class="nav-link"
            >Customers</a
          >
        </li>
        <li class="nav-item">
          <a
            href="javascript:;"
            @click="tab = 'Providers'"
            :class="{ active: tab == 'Providers' }"
            class="nav-link"
            >Providers</a
          >
        </li>
      </ul>
      <load-area v-if="data == null"></load-area>
      <dataTable
        v-if="data != null"
        :name="'OnlineReservationCustomer'"
        ref="agGrid"
        :data="data[tab]"
        :columnDefs="columnDefs"
        @cellClicked="detailShow = { ...$event.data }"
        @update="detailShow = { ...$event }"
        @remove="remove"
      ></dataTable>

      <modal
        v-if="detailShow != null"
        :title="detailShow.Name + ' Detail'"
        :size="'lg'"
        @close="detailShow = null"
      >
        <template #content>
          <dataTable
            v-if="data != null"
            :name="'OnlineReservationCustomer'"
            ref="agGrid"
            :data="detailShow[tab == 'Customers' ? 'Providers' : 'Customers']"
            :columnDefs="columnDefs"
            @cellClicked="detailShow = { ...$event.data }"
            @update="detailShow = { ...$event }"
            @remove="remove"
          ></dataTable>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "onlineReservationCustomer",
  // props:["data","get"],
  data() {
    return {
      tab: "Customers",
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 60,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
        },
        {
          headerName: "Wait",
          field: "Wait",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 100,
        },
        {
          headerName: "AgencyWait",
          field: "AgencyWait",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 120,
        },
        {
          headerName: "Total",
          field: "AgencyWait",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 120,
          comparator: (x, y, nodeX, nodeY) => {
            return x + nodeX.data.Wait - (y + nodeY.data.Wait);
          },
          valueFormatter: function(params) {
            return params.value + params.data.Wait;
          },
        },
      ],
      data: null,
      detailShow: null,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`KOLAYREZ/Reports/OnlineReservationScatter`)
        .then((response) => {
          this.data = response.data;
        });
    },
  },
};
</script>
<style scoped>
.countBox .head {
  position: relative;
}
.countBox .head h3 {
  position: relative;
  z-index: 3;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  font-weight: 600;
  padding: 50px 0;
}
.countBox .head img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
